import React, { PropTypes } from 'react';
import { Tabs, Tab } from 'material-ui';
import ExistingDriverTab from './ExistingDriverTab';
import NewDriverTab from './NewDriverTab';
import RedirectedDriverTab from './RedirectedDriverTab';

import {
  NitroHeading,
  NitroDivider,
  NitroTabs,
  NitroTextField,
} from 'nitro-components';

import {
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_CREATE_NEW_DRIVER,
} from '../content';
import TextField from 'material-ui/TextField';

const AllocateDifferentDriverTabs = ({
  country,
  company,
  driverProfile,
  existingDriverDetails,
  newDriverDetails,
  setDriverDetails,
  handleTabChange,
  tabValue,
}) => {
  if (driverProfile) {
    const { DriverFirstName, DriverSurname } = driverProfile;
    return (
      <section>
        <NitroHeading
          size="1"
          label={`Allocate ${DriverFirstName} ${DriverSurname}`}
          align="center"
          noMargin
        />
        <NitroDivider sidePanel />
        <RedirectedDriverTab
          country={country}
          driverDetails={existingDriverDetails}
          setDriverDetails={setDriverDetails}
          driverProfile={driverProfile}
        />
      </section>
    );
  }

  const tabs = [
    {
      key: 'existing',
      label: ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_SELECT_EXISTING_DRIVER,
    },
    {
      key: 'new',
      label: ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_CREATE_NEW_DRIVER,
    },
  ];

  const existingDriver = (
    <ExistingDriverTab
      country={country}
      company={company}
      driverDetails={existingDriverDetails}
      setDriverDetails={setDriverDetails}
    />
  );

  const newDriver = (
    <NewDriverTab
      country={country}
      driverDetails={newDriverDetails}
      setDriverDetails={setDriverDetails}
    />
  );

  return (
    <section>
      <NitroHeading
        size="1"
        label={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER}
        align="center"
        noMargin
      />
      <NitroDivider sidePanel />
      <NitroTabs
        center
        data={tabs}
        active={tabValue}
        underline
        action={handleTabChange}
      />
      {tabValue === 'existing' ? existingDriver : newDriver}
    </section>
  );
};

AllocateDifferentDriverTabs.propTypes = {
  country: PropTypes.object,
  company: PropTypes.object,
  newDriverDetails: PropTypes.object,
  existingDriverDetails: PropTypes.object,
  setDriverDetails: PropTypes.func,
  handleTabChange: PropTypes.func,
  tabValue: PropTypes.string,
  driverProfile: PropTypes.object,
};

export default AllocateDifferentDriverTabs;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/AllocateDifferentDriverTabs.js